import { SxProps, Theme } from '@mui/material';

export const fieldStyles = {
  textField: {
    width: '100%',
    '& .MuiInputBase-root': {
      height: '36px',
      fontSize: '16px',
      borderRadius: '4px'
    }
  } as SxProps<Theme>,

  multilineTextField: {
    width: '100%',
    '& .MuiInputBase-root': {
      height: 'auto',
      fontSize: '16px',
      borderRadius: '4px'
    }
  } as SxProps<Theme>,

  unitCostField: {
    '& .MuiInputBase-root': {
      height: '36px',
      fontSize: '16px',
      borderRadius: '4px'
    }
  } as SxProps<Theme>,

  errorHelperText: {
    color: "red",
    fontFamily: "Manrope",
    fontSize: "11px",
    marginLeft: "-11px",
  } as SxProps<Theme>,

  unitCostHelperText: {
    color: "red",
    fontFamily: "Manrope",
    fontSize: "11px",
    overflow: "hidden",
    width: "240px",
    marginLeft: "-11px",
  } as SxProps<Theme>,

  notesContainer: {
    ml: "24px",
    mt: "24px",
    width: "550px"
  } as SxProps<Theme>,

  dialogPaper: {
    maxWidth: '600px',
    width: '100%',
    maxHeight: '90vh',
    overflow: 'hidden'
  } as SxProps<Theme>,

  dialogContent: {
    paddingTop: "24px !important",
    overflow: 'auto',
    maxHeight: 'calc(90vh - 120px)'
  } as SxProps<Theme>,

  dialogTitle: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  } as SxProps<Theme>,

  actionButtonsContainer: {
    px: '24px'
  } as SxProps<Theme>
};
